import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { TributacaoCfopBuscarPorTributacaoId } from "src/services/Fiscal.Service";
import { MapearErrosServidor } from "src/hook/Functions";
import {
  TributacaoCfopDto,
  TributacaoCfopFiltrarDto,
  TributacaoCfopFiltrarSchema,
} from "./TributacaoCfop.Dto";
import { useSearchParams } from "react-router-dom";
import { showToast } from "src/componentes";

const TributacaoCfopCode = () => {
  const [data, setData] = useState<TributacaoCfopDto[] | undefined>([]);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [loading, setLoading] = useState(false);
  const form = useForm<TributacaoCfopFiltrarDto>({
    resolver: yupResolver(TributacaoCfopFiltrarSchema),
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      setLoading(true);
      if (id) {
        await TributacaoCfopBuscarPorTributacaoId(id)
          .then((response) => {
            if (response.data.success) {
              setData(response.data.data);
            }
          })
          .catch((error) => {
            console.log(error);
            showToast({
              message: "Ocorreu erro ao buscar dados",
              title: "Erro",
              variant: "Danger",
            });
            return undefined;
          })
          .finally(() => {
            setLoading(false);
          });
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, []);

  //corrigir para inclusão, codigo não finalizado
  const onSubmit = async (data: TributacaoCfopFiltrarDto, e: any) => {
    setLoading(true);
    try {
      const response = await TributacaoCfopBuscarPorTributacaoId("0");
      if (response.data.success) {
        const data = response.data.data;
        setData(data);
        if (data.length == 0) {
          showToast({
            message: "Não encontrado",
            title: "Info",
            variant: "Info",
          });
        }
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      setData(undefined);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    onSubmit,
    form,
  };
};

export default TributacaoCfopCode;
